import type { TypedClient } from '@platform/openapi';
import { nameIn } from '../catalog/categories.ts';
import { useActiveCategories, useTenantDetail } from '../catalog/useCatalogQueries.ts';
import { useSubsidiaries } from '../settings/subsidiaries.ts';
import { usePageContext } from '../usePageContext.ts';
import type { ValueContext } from './history-format.ts';

export const useValueContext = (api: TypedClient): ValueContext => {
  const { t, locale } = usePageContext();
  const currency = useTenantDetail(api).data?.currency ?? null;
  const categories = useActiveCategories(api).data?.items ?? [];
  const subsidiaries = useSubsidiaries(api).data ?? [];
  const names = new Map([
    ...categories.map((category) => [category.id, nameIn(category, locale, category.id)] as const),
    ...subsidiaries.map((subsidiary) => [subsidiary.id, subsidiary.name] as const),
  ]);
  return { t, locale, currency, names };
};
